export const RouterSelfInstallSteps = {
  INTRO: 'INTRO',
  LOADING: 'LOADING',
  NETCONFIG: 'NETCONFIG',
  SELFCHECK: 'SELFCHECK',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

export const NiudSteps = {
  NIUD: 'NIUD',
  UPDATESETTINGS: 'UPDATESETTINGS',
  ALMOSTFINISH: 'ALMOSTFINISH',
  CONFIGURING: 'CONFIGURING',
};
